$("#prevButton3").click(function (event) {
  $(".number-2").addClass("slected");
  $(".techn-section-door-frame-measurement").show();
  $("#step2").show();
  $("#step1").hide();
  $(".product").hide();
  $(".progress2").css("background", "#e6e4e4");
  $(".progress1").css("background", "#128ea9");
  $("#prevButton3").css("display", "none");
  $(".steps1").css("display", "none");
  $(".number-3").removeClass("slected");
  $("html, body").animate(
    {
      scrollTop: $(".steps").offset().top,
    },
    500
  );
});
$("#productbtnprev").click(function (event) {
  $(".number-2").addClass("slected");
  $(".techn-section-door-frame-measurement").show();
  $("#step2").show();
  $("#step1").hide();
  $(".product").hide();
  $(".progress2").css("background", "#e6e4e4");
  $(".progress1").css("background", "#128ea9");
  $("#prevButton3").css("display", "none");
  $(".steps1").css("display", "none");
  $(".number-3").removeClass("slected");
  $("html, body").animate(
    {
      scrollTop: $(".steps").offset().top,
    },
    500
  );
});
$(document).ready(function () {
  $("#confirmationModal").click(function (event) {
    if (!$(event.target).closest(".modal-content").length) {
      $(this).hide();
    }
  });

  $(".modal-content").click(function (event) {
    event.stopPropagation();
    console.log("Card clicked");
  });
});
